import { apis } from '../../../config';
import { api } from '../../../api/api';
class TaskApiImpl {
    constructor() {
        this.dbName = 'task_global';
        this.tableName = 'task';
        this.contactSyncTaskTableName = 'contact_synctask';
        this.isInited = false;
        this.name = apis.taskApiImpl;
        this.systemApi = api.getSystemApi();
        this.DBApi = api.getNewDBApi();
    }
    getEmail() {
        const user = this.systemApi.getCurrentUser();
        return (user === null || user === void 0 ? void 0 : user.id) || '';
    }
    doCreateTask(params) {
        const now = new Date().getTime();
        const items = Object.assign(params, {
            createTime: now,
            expired: now + 5 * 60 * 1000,
        });
        return this.DBApi.put({
            tableName: this.tableName,
            dbName: this.dbName,
        }, items);
    }
    async executeAfterLoginTask() {
        if (!this.systemApi.isMainWindow()) {
            return;
        }
        const account = this.getEmail();
        const res = (await this.DBApi.getByEqCondition({
            dbName: this.dbName,
            tableName: this.tableName,
            query: {
                action: 'AfterLogin',
                account,
            },
        }));
        const promiseList = [];
        const deleteTaskIdList = [];
        res.forEach(item => {
            if (item.expired >= new Date().getTime()) {
                if (item.to === 'mail') {
                    promiseList.push(this.readMailTask(item.content.mailId));
                }
                deleteTaskIdList.push(item.id);
            }
            else {
                deleteTaskIdList.push(item.id);
            }
        });
        await this.deleteExpiredTask(deleteTaskIdList);
        await Promise.all(promiseList);
    }
    readMailTask(mailId) {
        return this.systemApi.createWindowWithInitData({ type: 'readMail', additionalParams: { account: '' } }, { eventName: 'initPage', eventData: mailId, _account: '' });
    }
    deleteExpiredTask(idList) {
        return this.DBApi.deleteById({
            dbName: this.dbName,
            tableName: this.tableName,
        }, idList);
    }
    doUpdateContactSyncTask(params) {
        return this.DBApi.put({
            dbName: this.dbName,
            tableName: this.contactSyncTaskTableName,
        }, Object.assign(Object.assign({}, params), { id: this.systemApi.md5([params.account, params.domain, params.from].join(',')), expiredTime: Date.now() + 30 * 60 * 1000 }));
    }
    async doDeleteContactSyncTask(params) {
        const $id = this.systemApi.md5([params.account, params.domain, params.from].join(','));
        await this.DBApi.put({
            dbName: this.dbName,
            tableName: this.contactSyncTaskTableName,
        }, Object.assign(Object.assign({}, params), { id: $id, source: 'unknown', expiredTime: 0 }));
    }
    async getContactSyncTask(params) {
        const $id = this.systemApi.md5([params.account, params.domain, params.from].join(','));
        try {
            const result = (await this.DBApi.getByEqCondition({
                dbName: this.dbName,
                tableName: this.contactSyncTaskTableName,
                query: params,
            }));
            if (Array.isArray(result) && result.length > 0) {
                return result[0];
            }
        }
        catch (ex) {
            console.error('[task_impl]getContactSyncTask.error:', ex);
        }
        return Object.assign(Object.assign({}, params), { id: $id, account: params.account, source: 'unknown', expiredTime: 0 });
    }
    getContactDoneStep(param) {
        if (!param) {
            return 'none';
        }
        if (!Reflect.has(param, 'step') && param.isAll && param.expiredTime !== 0) {
            return param.isAll ? 'none' : 'increase';
        }
        if (param.step === 'core') {
            return 'core';
        }
        if (param.step === 'all') {
            return param.done ? 'all' : 'core';
        }
        if (param.step === 'increase') {
            return param.done ? 'increase' : 'all';
        }
        return 'none';
    }
    onPathChange(ev) {
        var _a;
        if (ev && ((_a = ev.curPath) === null || _a === void 0 ? void 0 : _a.pathname) === '/') {
            !this.isInited && this.afterInit();
        }
        return this.name;
    }
    afterInit() {
        if (this.isInited) {
            return this.name;
        }
        this.DBApi.initDb(this.dbName);
        this.executeAfterLoginTask().then().catch(console.warn);
        this.isInited = true;
        return this.name;
    }
    afterLogin() {
        return this.name;
    }
    init() {
        return this.name;
    }
}
const impl = new TaskApiImpl();
api.registerLogicalApi(impl);
export default impl;
